import { render, staticRenderFns } from "./RequestItemImageCard.vue?vue&type=template&id=47f1ea34&scoped=true&lang=pug"
import script from "./RequestItemImageCard.vue?vue&type=script&lang=js"
export * from "./RequestItemImageCard.vue?vue&type=script&lang=js"
import style0 from "./RequestItemImageCard.vue?vue&type=style&index=0&id=47f1ea34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1ea34",
  null
  
)

export default component.exports